import { ListElementType } from "domain/admin/common/AdministrationList";
import {
  ExamSyllabusAdminPageData_examSyllabusById_elements_content,
  FolderAdminPageData_folderById_elements_content,
  FolderType,
} from "__generated__/types";

export function getListElementType(
  element:
    | FolderAdminPageData_folderById_elements_content
    | ExamSyllabusAdminPageData_examSyllabusById_elements_content,
  // TODO: Probably several content types to be added as possible types here
): ListElementType {
  if (
    element.__typename === "Folder" &&
    element.type === FolderType.SELF_ASSESSMENT_EXERCISES
  ) {
    return "SelfAssessment";
  } else if (
    element.__typename === "Folder" &&
    element.type === FolderType.SELF_ASSESSMENT_EXERCISES_CONTAINER
  ) {
    return "SelfAssessmentsContainer";
  } else {
    return element.__typename;
  }
}
